<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="ttleft">
        <span>我的展示</span>
      </div>
      <div class="ttright"
           v-show="isfabu"
           @click="toFabu">
        <span>发布</span>
      </div>
    </div>
    <div class="top1">
      <span>视频封面：</span>
      <div>
        <webupload fileaccept=".jpg,.jpeg,.png"
                   :Maxfileszie="3"
                   :uploadtype="2"
                   :orgid="orgid"
                   :before-upload="beforeAvatarUpload"
                   :onSuccess="handleSuccess">
          <div class="addImg">
            <span v-show="!imgUrl"
                  style="font-weight: 100;font-size: 40px;">+</span>
            <span v-show="!imgUrl">图片上传</span>
            <img v-show="imgUrl"
                 :src="imgUrl"
                 alt="">
          </div>
        </webupload>
        <span class="addtop2">支持jpg,jpeg,png格式，图片小于2M；图片比例670*440</span>
      </div>
    </div>
    <div class="addtop3">
      <span>视频标题：</span>
      <el-input placeholder="请输入视频标题"
                v-model="title"
                style="width:494px"
                clearable>
      </el-input>
    </div>
    <div class="addtop4">
      <span>视频简介：</span>
      <!-- <el-input type="textarea"
                class="addjianjie"
                placeholder="请输入视频简介"
                v-model="jianjie">
      </el-input> -->
      <div class="addjianjie"
           ref="videoEditer"></div>
    </div>
    <span class="addtop2"
          style="margin-left:80px">建议行高1.6、字号16、字体微软雅黑、两端对齐、首行空2个字</span>
    <div class="addtop4">
      <span>视频上传：</span>
      <webupload fileaccept=".mp4"
                 :Maxfileszie="1024"
                 :uploadtype="2"
                 :orgid="orgid"
                 class="addt4box"
                 :onSuccess="handleSuccess2">
        <div class="addmp4box"
             v-show="!mp4name">
          <img src="../../assets/img/icon/import.png"
               alt="">
          <span>上传视频</span>
        </div>
        <div v-show="mp4name"
             class="mp4name">
          <img src="../../assets/img/icon/qubiezhen.png"
               alt="">
          <span>{{mp4name}}</span>
        </div>
      </webupload>
      <span class="span"
            v-show="!mp4name">支持扩展名：mp4格式</span>
    </div>
    <div class="addtop5">
      <div @click="ToSub">
        <span>保存</span>
      </div>
      <!-- <div style="background: #BDC1C1;"
           @click="isadd=false">
        <span>取消</span>
      </div> -->
    </div>
  </div>
</template>

<script>
import E from 'wangeditor';
import webupload from '../../components/webupload/webupload.vue';
export default {
  name: 'usInfor',
  components: {
    webupload
  },
  data () {
    return {
      storeName: '',
      imgUrl: '',
      jianjie: '',
      title: '',
      orgid: 0,
      imgId: 0,
      mp4url: '',
      mp4id: 0,
      mp4name: '',
      id: 0,
      uid: 0,
      isfabu: false,
      editor: null
    };
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
    this.orgid = Number(localStorage.getItem('storeId'))
    this.uid = Number(JSON.parse(localStorage.getItem('ResData')).id)
    this.getShow()
    this.GetMyStoreList()
  },
  mounted () {
    var that = this;
    that.editor = new E(this.$refs.videoEditer);
    that.editor.config.menus = [
      'head',
      'bold',
      'fontSize',
      'fontName',
      'italic',
      'underline',
      'strikeThrough',
      'indent',
      'lineHeight',
      'foreColor',
      'link',
      'list',
      'justify',
      'undo',
      'redo'
    ];
    that.editor.config.onchange = function (newHtml) {
      that.jianjie = newHtml;
    };
    that.editor.config.onchangeTimeout = 500;
    that.editor.create();
    that.editor.txt.html(this.jianjie)
  },
  methods: {
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    handleSuccess (response) {
      this.imgId = response.resid;
      this.imgUrl = response.ossfileurl;
    },
    handleSuccess2 (response, file) {
      this.mp4id = response.resid;
      this.mp4url = response.ossfileurl;
      this.mp4name = file.name
    },
    ToSub () {
      if (this.title == '') return this.$message.warning('请输入视频标题');
      if (this.jianjie == '') return this.$message.warning('请输入视频简介');
      if (this.mp4id == '') return this.$message.warning('请上传视频或视频上传未完成');
      if (this.imgId == '') return this.$message.warning('请上传封面');
      this.httphelper
        .post('/api/EnterpriseApi/SaveOrganVisit', {
          id: this.id,
          title: this.title,
          abstract: this.jianjie,
          resId: this.mp4id,
          resUrl: this.mp4url,
          type: 2,
          coverPictureUrl: this.imgUrl,
          coverPictureId: this.imgId,
          sort: 0,
          orgId: this.orgid,
          isShow: true,
          createUserID: this.uid
        })
        .then(res => {
          if (res.data.code == 200) {
            this.GetMyStoreList()
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.title = ''
            this.jianjie = ''
            this.imgId = 0
            this.imgUrl = ''
            this.id = 0
            this.mp4id = 0
            this.mp4url = ''
          }
        });
    },
    GetMyStoreList () {
      this.httphelper
        .post('api/EnterpriseApi/GetOrganVisitList', {
          type: 2,
          orgId: this.orgid,
          page: 1,
          limit: 10
        })
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.length == 0) {
              return
            } else {
              this.id = res.data.data[0].id
              this.getInfo(res.data.data[0].id);
            }
          }
        });
    },
    getInfo (id) {
      this.httphelper
        .post('/api/EnterpriseApi/GetOrganVisitInfoByID', {
          id: id
        })
        .then(res => {
          if (res.data.code == 200) {
            this.id = res.data.data.id
            this.title = res.data.data.title
            this.jianjie = res.data.data.abstract
            this.imgId = res.data.data.coverPictureId
            this.imgUrl = res.data.data.coverPictureUrl
            this.mp4name = res.data.data.audioResName
            this.mp4id = res.data.data.resId
            this.mp4url = res.data.data.resUrl
            this.isadd = true
            if (this.editor != null) {
              this.editor.txt.html(this.jianjie)
            }
          }
        });
    },
    toFabu () {
      this.httphelper
        .post('api/EnterpriseApi/SaveOrganVisitConfig', {
          orgId: this.orgid,
          type: 2,
          createUserID: this.uid
        })
        .then(res => {
          if (res.data.code == 200) {
            this.$message.success('发布视频展示成功');
            this.$router.push({
              name: 'usShow'
            })
          }
        });
    },
    getShow () {
      this.httphelper
        .post('/api/CGPEnterPriseApi/GetOrganVisitList', {
          orgId: Number(localStorage.getItem('storeId'))
        })
        .then(res => {
          if (res.data.code == 200) {
            if (res.data.data.length == 0) {
              this.isfabu = true
              return
            }
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].type != 2) {
                this.isfabu = true
              }
            }
          }
        });
    },
  }
};
</script>

<style scoped>
.toptitle {
    width: 100%;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    padding-right: 20px;
    margin: 30px 0 40px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;
}
.ttleft {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0b8586;
    line-height: 56px;
}
.ttright {
    width: 100px;
    height: 30px;
    background: #0b8586;
    border: 1px solid #0b8586;
    border-radius: 15px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
}
.top1 {
    display: flex;
}
.top1 .addImg {
    width: 160px;
    height: 104px;
    background: #ffffff;
    border: 1px solid #e6e6e6;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #a8a8a8;
    align-items: center;
    justify-content: space-around;
}
.addImg img {
    width: 160px;
    height: 104px;
    border-radius: 5px;
    cursor: pointer;
}
.addtop2 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #0b8586;
    line-height: 56px;
    margin-bottom: 6px;
}
.addtop3 {
    display: flex;
    align-items: center;
}
.addtop4 {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 15px;
    position: relative;
}
.addjianjie {
    width: 892px;
    height: 172px;
}
.addjianjie ::v-deep .w-e-text-container {
    height: 130px !important;
}
.addjianjie ::v-deep .w-e-text {
    min-height: 130px !important;
}
.addmp4box {
    width: 113px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    padding: 0 13px;
    box-sizing: border-box;
    cursor: pointer;
}
.addtop5 {
    margin-top: 63px;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
}
.addtop5 div {
    width: 165px;
    height: 40px;
    background: #0b8586;
    border-radius: 20px;
    line-height: 40px;
    text-align: center;
    margin: 0 5px;
    color: #ffffff;
    cursor: pointer;
}
/* .addt4box {
    display: flex;
    align-items: center;
    justify-content: flex-start;
} */
.addtop4 .span {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-left: 10px;
    margin-top: 10px;
    position: relative;
}
.mp4name {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
}
.mp4name img {
    margin-right: 10px;
}
</style>